module.exports = __webpack_public_path__ + "img/page1_06.79e6fd40.jpg";